var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card my-4 mx-3 p-2 shadow-sm search-bar-card" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between px-2 cursor-pointer",
          on: {
            click: function ($event) {
              _vm.isCollapsed = !_vm.isCollapsed
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("b-icon", {
                staticClass: "icon-size",
                attrs: { icon: "stars", scale: "1" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted font-semibold" }, [
                _vm._v("AI Assistant"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "bi cursor-pointer",
            class: !_vm.isCollapsed ? "bi-chevron-up" : "bi-chevron-down",
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { staticClass: "px-2 mb-3", attrs: { visible: !_vm.isCollapsed } },
        [
          _c(
            "div",
            {
              staticClass:
                "title-container d-flex align-items-center mb-2 mt-4",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "rounded-circle stars-icon d-flex align-items-center justify-content-center p-3 mr-2",
                },
                [
                  _c("b-icon", {
                    staticClass: "icon-size",
                    attrs: { icon: "stars", scale: "1.5" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("strong", { staticStyle: { color: "#101828" } }, [
                  _vm._v("\n          What do you want to create?\n        "),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "title-text mb-2" }, [
                  _vm._v(
                    "\n          Describe a campaign, layout or placement to get started\n        "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-100" }, [
            _c("div", { staticClass: "ai-agent-chat-wrapper" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center space-x-2" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.prompt,
                        expression: "prompt",
                      },
                    ],
                    ref: "promptTextarea",
                    staticClass: "form-control ai-agent-input flex-grow-1 mr-2",
                    attrs: {
                      placeholder: "e.g Create a Walmart Connect campaign",
                      rows: "1",
                    },
                    domProps: { value: _vm.prompt },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendMessage.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.prompt = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary d-flex align-items-center justify-content-center",
                      attrs: {
                        type: "button",
                        disabled: _vm.isSendingMessage,
                        "aria-label": "Send",
                      },
                      on: { click: _vm.sendMessage },
                    },
                    [
                      _vm.isSendingMessage
                        ? _c("span", {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status", "aria-hidden": "true" },
                          })
                        : _c("i", { staticClass: "cil-send" }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "common-search d-flex align-items-center mt-3 flex-wrap gap-2",
            },
            _vm._l(_vm.suggestions, function (suggestion, index) {
              return _c(
                "button",
                {
                  key: index,
                  staticClass: "walmart-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.useSuggestion(suggestion)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(suggestion) + "\n      ")]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }